// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1DxWQ","range":"MonthRangeSwitch_range__3_hx_","disabled":"MonthRangeSwitch_disabled__1b9Pr"};